import CircleStyleTextBox from '../circleStyleTextBox/circleStyleTextBox';
import DOMPurify from 'dompurify';
import styles from './bag.module.css';
import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const Bag = ({ m2sText }) => {
  useEffect(() => {
    gsap.to(document.body, {
      scrollTrigger: {
        trigger: `.${styles.ctn}`,
        start: 'bottom bottom',
        toggleActions: 'play complete none reverse',
      },
      backgroundColor: 'white',
      duration: 0,
    });
  });
  return (
    <div className={`${styles.ctn} m2s-section fullscreen`}>
      <CircleStyleTextBox className={styles.textBox}>
        <h2
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(m2sText['text27']),
          }}
        ></h2>

        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(m2sText['text28']),
          }}
        ></h5>


      </CircleStyleTextBox>
        <video
          autoPlay
          loop
          playsInline
          muted
          src="https://bucket.zhiyun-tech.com/detail/m2s/m2s-bag-video.mp4"
          alt=""
          className={styles.video}
        />
        <h6>{m2sText['text29']}</h6>
    </div>
  );
};

export default Bag;
